import React from 'react';
import { List, Button, Space, Typography, Empty } from 'antd';
import type { Contact } from '@/types/common';

const { Text } = Typography;

interface ContactsListProps {
  contacts: Contact[];
  onEditContact?: (contact: Contact) => void;
  onDeleteContact?: (contact: Contact) => void;
}

const ContactsList: React.FC<ContactsListProps> = ({ contacts, onEditContact, onDeleteContact }) => {
  if (!contacts || contacts.length === 0) {
    return <Empty description="No contacts" />;
  }
  return (
    <List
      dataSource={contacts}
      renderItem={(contact: Contact) => (
        <List.Item
          actions={[
            onEditContact && <Button type="link" onClick={() => onEditContact(contact)}>Edit</Button>,
            onDeleteContact && <Button type="link" danger onClick={() => onDeleteContact(contact)}>Delete</Button>,
          ].filter(Boolean)}
        >
          <List.Item.Meta
            title={contact.name}
            description={
              <Space direction="vertical" size={0}>
                <Text type="secondary">Email: {contact.email}</Text>
                <Text type="secondary">Phone: {contact.phone}</Text>
              </Space>
            }
          />
        </List.Item>
      )}
    />
  );
};

export default ContactsList; 